import React, { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlayCircle,
  faPauseCircle
} from "@fortawesome/free-solid-svg-icons";
import "./webzoomcoloraudio.css";

function WebZoomColorAudio() {
  const audioplay = <FontAwesomeIcon icon={faPlayCircle} />;
  const audiopause = <FontAwesomeIcon icon={faPauseCircle} />;

  // --------------------------------
  // Font Size
  // --------------------------------

  const fontChangeLevel = useRef(0);

  const applyFontChange = (level) => {
    const elements = document.querySelectorAll("body *");

    elements.forEach((el) => {
      if (!el.textContent.trim()) return;

      const style = window.getComputedStyle(el);
      const currentSize = parseFloat(style.fontSize);

      if (!el.dataset.baseFontSize) {
        el.dataset.baseFontSize = currentSize;
      }

      const newSize =
        parseFloat(el.dataset.baseFontSize) + level;

      el.style.fontSize = `${newSize}px`;
    });
  };

  const handleIncreaseFont = () => {
    if (fontChangeLevel.current < 3) {
      fontChangeLevel.current += 1;
      applyFontChange(fontChangeLevel.current);
    }
  };

  const handleDecreaseFont = () => {
    if (fontChangeLevel.current > -3) {
      fontChangeLevel.current -= 1;
      applyFontChange(fontChangeLevel.current);
    }
  };

  const handleResetFont = () => {
    fontChangeLevel.current = 0;

    const elements = document.querySelectorAll("body *");

    elements.forEach((el) => {
      el.style.fontSize = "";
      delete el.dataset.baseFontSize;
    });
  };

  // --------------------------------
  // Background
  // --------------------------------

  const bgClasses = [
    "darkbg1",
    "yellowbg1",
    "bluebg1",
    "orangebg1",
    "whitebg1"
  ];

  const handleSetBackground = (className) => {
    const elements = document.querySelectorAll("body *");

    elements.forEach((el) => {
      const style = window.getComputedStyle(el);

      const hasText = el.textContent.trim() !== "";

      const hasBackground =
        style.backgroundColor &&
        style.backgroundColor !== "rgba(0, 0, 0, 0)" &&
        style.backgroundColor !== "transparent";

      if (hasText || hasBackground) {
        bgClasses.forEach((cls) => {
          el.classList.remove(cls);
        });

        if (className) {
          el.classList.add(className);
        }
      }
    });
  };

  const handleResetBackground = () => {
    handleSetBackground(null);
  };

  // --------------------------------
  // Text To Speech
  // --------------------------------

  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  // Keep text outside React state
  const speechTextRef = useRef("");

  // --------------------------------
  // Create Page Text
  // --------------------------------

  const getPageText = () => {
    const clone = document.body.cloneNode(true);

    // Remove audio toolbar
    const audio = clone.querySelector(
      ".zoomcoloraudio-section"
    );

    if (audio) {
      audio.remove();
    }

    // Stop animations
    clone.querySelectorAll("*").forEach((el) => {
      el.style.animation = "none";
      el.style.transition = "none";
    });

    // Remove duplicate slides
    clone
      .querySelectorAll(".swiper-slide-duplicate")
      .forEach((item) => {
        item.remove();
      });

    clone
      .querySelectorAll(".slick-cloned")
      .forEach((item) => {
        item.remove();
      });

    return clone.innerText.trim();
  };

  // --------------------------------
  // PLAY / RESUME
  // --------------------------------

  const handlePlay = () => {
    console.log("PLAY CLICKED");

    // --------------------------------
    // If currently paused -> RESUME
    // --------------------------------

    if (isPaused) {
      console.log("RESUME CLICKED");

      if (window.responsiveVoice) {
        window.responsiveVoice.resume();

        setIsPaused(false);
        setIsSpeaking(true);
      }

      return;
    }

    // --------------------------------
    // New Speech
    // --------------------------------

    const text = getPageText();

    speechTextRef.current = text;

    console.log(
      "TEXT FOR SPEECH ===",
      speechTextRef.current
    );

    if (!text) {
      console.log("No text found");
      return;
    }

    // Make sure previous speech is stopped
    if (window.responsiveVoice) {
      window.responsiveVoice.cancel();

      window.responsiveVoice.speak(
        speechTextRef.current,
        "UK English Female",
        {
          rate: 1,
          pitch: 1,
          volume: 1,

          onstart: () => {
            console.log("SPEECH STARTED");

            setIsSpeaking(true);
            setIsPaused(false);
          },

          onend: () => {
            console.log("SPEECH ENDED");

            setIsSpeaking(false);
            setIsPaused(false);
          }
        }
      );
    }
  };

  // --------------------------------
  // PAUSE
  // --------------------------------

  const handlePause = () => {
    console.log("PAUSE CLICKED");

    if (window.responsiveVoice) {
      window.responsiveVoice.pause();

      setIsSpeaking(false);
      setIsPaused(true);
    }
  };


    return (
        <div className="zoomcoloraudio-section">
            <div className="container">
            <ul className="zoomcoloraudio-list">
                <li>
        <span
          id="mnskhincfont"
          title="Increase Font"
          className="fontincreasefont"
          onClick={handleIncreaseFont}
        >
          (A)+
        </span>
      </li>
      <li>
        <span
          id="mnskhresetfont"
          title="Reset Font"
          className="fontreset"
          onClick={handleResetFont}
        >
          (A)
        </span>
      </li>
      <li>
        <span
          id="mnskhdecfont"
          title="Decrease Font"
          className="fontdecreasefont"
          onClick={handleDecreaseFont}
        >
          (A)-
        </span>
      </li>
              
       <li>
        <span
          className="mnskhdsitebg darkbg text-white"
          title="Dark Font"
          onClick={() => handleSetBackground("darkbg1")}
        >
        A
        </span>
      </li>
      <li>
        <span
          className="mnskhdsitebg whitebg"
          title="Light Font"
          onClick={handleResetBackground}
        >
        A
        </span>
      </li>
      <li>
        <span
          className="mnskhdsitebg yellowbg"
        
          title="Yellow Font"
          onClick={() => handleSetBackground("yellowbg1")}
        >
        </span>
      </li>
      <li>
        <span
          className="mnskhdsitebg bluebg"
        
          title="Blue Font"
          onClick={() => handleSetBackground("bluebg1")}
        >
          
        </span>
      </li>
      <li>
        <span
          className="mnskhdsitebg orangebg"
        
          title="Orange Font"
          onClick={() => handleSetBackground("orangebg1")}
        >
         
        </span>
      </li>
      <li className="audioplaypause">
            {!isSpeaking ? (
              <span
                className="audioplaypause-btn"
                title="Play Button"
                onClick={handlePlay}
              >
             {audioplay}
              </span>
            ) : (
              <span
                className="audioplaypause-btn"
                title="Pause Button"
                onClick={handlePause}
              >
               {audiopause}
              </span>
            )}
          </li>
                {/* <li className="audioplaypause">
                    <span class="audioplaypause-btn" title="Play Button">{audioplay}</span>
                    <span class="audioplaypause-btn" title="Pause Button">{audiopause}</span>
                </li> */}
            </ul>
            </div>
        </div>
    );
}
export default WebZoomColorAudio;
